'use client';

import { TYPOGRAPHY } from '../../styles/theme-config/themeConstants';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = (theme, bannerMobile, bannerTablet, bannerDesktop) => ({
  bannerContainer: {
    minHeight: '18.75rem',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      background: `url(${bannerMobile}) no-repeat center/cover`,
      backgroundColor: theme.palette.backgroundColor,
      minHeight: '32.2rem',
    },
    [theme.breakpoints.up('sm')]: {
      background: `url(${bannerTablet}) right/cover no-repeat`,
      backgroundColor: theme.palette.backgroundColor,
    },
    [theme.breakpoints.up('md')]: {
      background: `url(${bannerDesktop}) 100% 100%/cover no-repeat `,
      backgroundColor: theme.palette.backgroundColor,
    },
  },
  bannerDetails: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },
  bannerBoxContainer: {
    m: '0 auto',
    p: '0 1.5rem',
    [theme.breakpoints.down('sm')]: {
      p: 0,
    },
  },
  bannerBox: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      p: '3.5rem 1rem 0 1rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      pl: '2.5rem',
    },
  },
  bannerTitle: {
    color: theme?.palette?.textHeading,
    letterSpacing: 'inherit',
  },
  bannerDescription: {
    pt: '1rem',
    color: theme?.palette?.textBody,
    /* TBU subtitle 3 is introduced in theme as apart of accesibility project EDQ-6937 */
    fontWeight: TYPOGRAPHY?.h6?.fontWeight,
    fontSize: TYPOGRAPHY?.body3Medium?.fontSize,
    fontFamily: TYPOGRAPHY?.h6?.fontFamily,
    letterSpacing: 'inherit',
    [theme.breakpoints.down('sm')]: {
      p: '2rem 2rem 0 2rem',
    },
  },
  bannerCTA: {
    pt: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      p: '2rem 3rem 0 3rem',
    },
  },
});
